import { thunk } from 'easy-peasy';
import { API } from '@aws-amplify/api';
import awsApiConfig from './config/awsApiConfigure';

import {
  LIST_ORDER_COUPONS_FOR_BACKFILL,
  LIST_PREINTER_COUPONS_FOR_BACKFILL,
  LIST_INTERVENTION_COUPONS_FOR_BACKFILL,
  UPDATE_ORDER_COUPON_ORDERTYPE,
  UPDATE_PREINTER_COUPON_ORDERTYPE,
  UPDATE_INTERVENTION_COUPON_ORDERTYPE,
} from "../../graphql/customMutations"; // adapte le chemin

const PAGE_SIZE = 1000; // à ajuster si besoin

API.configure(awsApiConfig);

const CouponPreInterMiddleware = {
  //✨✨==========================================✨✨
  //            GET PRE COUPON
  //✨✨==========================================✨✨
  getPreCoupon: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
    query MyQuery {
      getCouponPreInter(id: "${payload}") {
        id
        ctm
        createdAt
        materials
        numero
        signed
        dateSigned
        orderCoupon
        newMailClient
        worksites {
          address
          name
          date_planned
          company {
              name
              mail
              phone
              siret
              address
          }
        }
      }
    }`;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.getCouponPreInter;
      return {
        ...myData,
        materials: (() => {
          try {
            const raw = myData?.materials;
            if (!raw || raw === 'null' || raw === 'undefined') return [];
            const parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed : [];
          } catch (e) {
            return [];
          }
        })(),
      };
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),

  //✨✨==========================================✨✨
  //          LIST PRE COUPON BY WORKSITE
  //✨✨==========================================✨✨
  listPreCouponByWorksite: thunk(async (actions, payload, { getStoreActions }) => {
    const { worksiteId, limit = 50, nextToken = null } = payload;

    if (!worksiteId) {
      return { items: [], nextToken: null };
    }

    const graphqlQuery = `
    query ListPreCouponByWorksite($worksiteId: ID!, $limit: Int, $nextToken: String) {
      couponPreIntersByWorksite(
        couponPreInterWorksitesId: $worksiteId,
        sortDirection: DESC,
        limit: $limit,
        nextToken: $nextToken
      ) {
        items { id numero materials dateSigned }
        nextToken
      }
    }
  `;

    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
        variables: { worksiteId, limit, nextToken },
      });

      const result = query.data?.couponPreIntersByWorksite;
      return {
        items: result?.items ?? [],
        nextToken: result?.nextToken ?? null,
      };
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  //✨✨==========================================✨✨
  //          LAST NUMBER PRE INTERVENTION
  //✨✨==========================================✨✨
  getNextCounterValue: thunk(
    async (actions, payload, { getStoreActions }) => {
      const globalActions = getStoreActions().global;

      // 📌 Variables envoyées à la mutation (id du compteur)
      const variables = { id: payload };

      // 📌 Mutation GraphQL propre (comme sur admin)
      const graphqlQuery = `
      mutation GetNextCounterValue($id: ID!) {
        getNextCounterValue(id: $id)
      }
    `;

      try {
        globalActions.setActivity(true);

        // 🔹 Appel via API.graphql (admin)
        const res = await API.graphql({
          query: graphqlQuery,
          variables,
        });

        // 🔹 Le backend renvoie un Int → on cast en String
        const numero = String(res?.data?.getNextCounterValue ?? "");

        return numero;
      } catch (error) {
        console.error("❌ Error getNextCounterValue:", error);
        throw error;
      } finally {
        globalActions.setActivity(false);
      }
    }
  ),

  //✨✨==========================================✨✨
  //          CREATE PRE INTERVENTION COUPON
  //✨✨==========================================✨✨
  createPreInterv: thunk(async (actions, payload, { getStoreActions }) => {
    if (!payload?.couponPreInterWorksitesId) {
      throw new Error("Impossible de créer le bon : chantier non renseigné.");
    }

    const graphqlQuery = /* GraphQL */ `
    mutation CreateCouponPreInter($input: CreateCouponPreInterInput!) {
      createCouponPreInter(input: $input) {
        id
        couponPreInterWorksitesId
        createdAt
      }
    }
  `;

    const input = {
      orderType: "PRE_INTERVENTION", // optionnel mais ok
      ctm: payload.ctm,
      numero: payload.numero,
      couponPreInterWorksitesId: payload.couponPreInterWorksitesId,
      materials: JSON.stringify(payload.materials ?? []),
    };

    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
        variables: { input },
      });
      return query.data?.createCouponPreInter;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),


  //✨✨==========================================✨✨
  //          UPDATE LIST MATERIAL
  //✨✨==========================================✨✨
  updateListMaterial: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
    mutation MyMutation {
      updateCouponPreInter(input: {
        id: "${payload.id}", 
        materials: "${JSON.stringify(payload?.materials).replace(/\"/g, '\\"')}"
      })
      {
        id
      }
    }
    `;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.updateCouponPreInter;
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),

  //✨✨==========================================✨✨
  //          DELETE INTERVENTION COUPON
  //✨✨==========================================✨✨
  deleteInterventioncoupon: thunk(async (actions, payload, { getStoreActions, getStoreState }) => {
    // body request
    const graphqlQuery = `
    mutation MyMutation {
      deleteCouponPreInter(input: {
        id: "${payload}", 
      })
      {
        id
      }
    }
    `;
    getStoreActions().global.setActivity(true);
    try {
      const query = await API.graphql({
        query: graphqlQuery,
      });
      const myData = query.data?.deleteCouponPreInter;
      return myData;
    } finally {
      getStoreActions().global.setActivity(false);
    }
  }),
};

export default CouponPreInterMiddleware;

